import { bl_cms_calendar_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_hdr.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsCalendarHdrContainerModel extends BaseContainerModel{
    bl_cms_calendar_hdr: bl_cms_calendar_hdr_RowClass = new bl_cms_calendar_hdr_RowClass();
}